import { c as _c } from "react/compiler-runtime";
import { ExtendedTitleCode, NewsletterSubscribeFormFields } from './newsletterSubscribeFormTypes';
import FormGroupComponent, { InputType } from '@spa/components/form-group/form-group.component';
import { FormikErrors, FormikHelpers, FormikTouched } from 'formik';
import FormikWithHoney, { WithHoneypot } from '@spa/components/forms/formik-with-honey/formikWithHoney.component';
import ButtonComponent from '@spa/components/button/button/button.component';
import { ButtonType } from '@spa/components/button/types/ButtonType';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { ReactElement } from 'react';
import { User } from 'next-auth';
import newsletterSubscribeFormSchemaValidationV2 from '@spa/components/forms/newsletter-subscribe-form/newsletterSubscribeFormSchemaV2';
import styles from './newsletter-subscribe-form.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
import { useNewsletter } from '@spa/lib/react/context/NewsletterContext';
import { useSession } from 'next-auth/react';
interface NewsletterSubscriber {
  readonly email: string;
  readonly firstName: string | null;
  readonly lastName: string | null;
  readonly titleCode: ExtendedTitleCode;
}
export interface Props {
  readonly isSubmitting: boolean;
  readonly handleSubmit: (values: WithHoneypot<NewsletterSubscribeFormFields>) => Promise<void> | void;
  readonly honeypotToken: string;
  readonly subscriber?: NewsletterSubscriber;
}
function NewsletterSubscribeForm(t0) {
  const $ = _c(19);
  const {
    isSubmitting,
    handleSubmit,
    honeypotToken,
    subscriber
  } = t0;
  const {
    data
  } = useSession();
  const userEmail = useNewsletter().email;
  const userData = data?.user;
  const {
    formatMessage
  } = useNamespacedIntl("newsletter");
  const {
    formatMessage: formsFormatMessage
  } = useNamespacedIntl("forms");
  const t1 = (userData?.email || userEmail) ?? "";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      email: t1,
      consent: false
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let initialFormValuesV2 = t2;
  if (subscriber) {
    let t3;
    if ($[2] !== subscriber.email) {
      t3 = {
        email: subscriber.email,
        consent: true
      };
      $[2] = subscriber.email;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    initialFormValuesV2 = t3;
  }
  const t3 = initialFormValuesV2;
  let t4;
  if ($[4] !== formsFormatMessage) {
    t4 = newsletterSubscribeFormSchemaValidationV2(formsFormatMessage);
    $[4] = formsFormatMessage;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== handleSubmit) {
    t5 = async (values, t6) => {
      const {
        setSubmitting
      } = t6;
      await handleSubmit(values);
      setSubmitting(false);
    };
    $[6] = handleSubmit;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== formatMessage || $[9] !== formsFormatMessage || $[10] !== isSubmitting || $[11] !== subscriber) {
    t6 = t7 => {
      const {
        errors,
        touched,
        values: values_0,
        isValid,
        dirty
      } = t7;
      const {
        consent: consentError,
        email: emailError
      } = errors;
      const {
        consent: consentTouched,
        email: emailTouched
      } = touched;
      const {
        email: emailValue
      } = values_0;
      return <div className={styles["newsletter-subscribe-form"]}><div className={styles["newsletter-subscribe-form__container"]}><h3 className="h3 bold">{formatMessage("contactDetails")}</h3><div className={styles["newsletter-subscribe-form__form"]}><div className={styles["newsletter-subscribe-form__input-area"]}><FormGroupComponent id="newsletter-subscribe-form" label={formsFormatMessage("fields.email")} name="email" touched={emailTouched} error={emailError} value={emailValue} type={InputType.EMAIL} isDisabled={isSubmitting} autoComplete="email" required={true} hideRequiredAsterisk={true} /></div>{subscriber === undefined && <div className={styles["newsletter-subscribe-form__consent"]}><h4 className="h4 bold">{formatMessage("consent")}</h4><FormGroupComponent id="newsletter-subscribe-form" label={<span dangerouslySetInnerHTML={{
                __html: formatMessage("consentText")
              }} />} touched={consentTouched} error={consentError} name="consent" type={InputType.CHECKBOX} isDisabled={isSubmitting} required={true} hideRequiredAsterisk={true} /></div>}<div className={styles["newsletter-subscribe-form__action"]}><ButtonComponent buttonType={ButtonType.SECONDARY} text={formsFormatMessage("buttons.basicSubmit")} type="submit" disabled={isSubmitting} looksDisabled={isValid && dirty} /></div></div></div></div>;
    };
    $[8] = formatMessage;
    $[9] = formsFormatMessage;
    $[10] = isSubmitting;
    $[11] = subscriber;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== honeypotToken || $[14] !== initialFormValuesV2 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <FormikWithHoney initialValues={t3} validationSchema={t4} honeypotToken={honeypotToken} onSubmit={t5}>{t6}</FormikWithHoney>;
    $[13] = honeypotToken;
    $[14] = initialFormValuesV2;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}
export default NewsletterSubscribeForm;